// Import des locales nécessaires pour Day.js
import 'dayjs/locale/fr';
import 'dayjs/locale/en';
import 'dayjs/locale/de';

/**
 * Retourne le code de locale Day.js à partir de la langue i18n
 */
const getDayjsLocale = (lang: string): string => {
    // On garde seulement la partie avant le tiret
    const short = lang.split('-')[0];
    switch (short) {
        case 'fr':
            return 'fr';
        case 'de':
            return 'de';
        default:
            return 'en';
    }
};

export { getDayjsLocale };
